export default "__VITE_ASSET__JDOB2h4r__"